import React from 'react';
import RootSvg, { RootSvgProps } from '@/components/icons/RootSvg';

export default function SvgOverView(props: RootSvgProps) {
  return (
    <RootSvg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_4628_55454)">
        <path
          d="M9.16732 14.9987C9.16732 15.9154 8.41732 16.6654 7.50065 16.6654C6.58398 16.6654 5.83398 15.9154 5.83398 14.9987C5.83398 14.082 6.58398 13.332 7.50065 13.332C8.41732 13.332 9.16732 14.082 9.16732 14.9987ZM7.50065 8.33203C6.58398 8.33203 5.83398 9.08203 5.83398 9.9987C5.83398 10.9154 6.58398 11.6654 7.50065 11.6654C8.41732 11.6654 9.16732 10.9154 9.16732 9.9987C9.16732 9.08203 8.41732 8.33203 7.50065 8.33203ZM7.50065 3.33203C6.58398 3.33203 5.83398 4.08203 5.83398 4.9987C5.83398 5.91536 6.58398 6.66536 7.50065 6.66536C8.41732 6.66536 9.16732 5.91536 9.16732 4.9987C9.16732 4.08203 8.41732 3.33203 7.50065 3.33203ZM12.5006 6.66536C13.4173 6.66536 14.1673 5.91536 14.1673 4.9987C14.1673 4.08203 13.4173 3.33203 12.5006 3.33203C11.584 3.33203 10.834 4.08203 10.834 4.9987C10.834 5.91536 11.584 6.66536 12.5006 6.66536ZM12.5006 8.33203C11.584 8.33203 10.834 9.08203 10.834 9.9987C10.834 10.9154 11.584 11.6654 12.5006 11.6654C13.4173 11.6654 14.1673 10.9154 14.1673 9.9987C14.1673 9.08203 13.4173 8.33203 12.5006 8.33203ZM12.5006 13.332C11.584 13.332 10.834 14.082 10.834 14.9987C10.834 15.9154 11.584 16.6654 12.5006 16.6654C13.4173 16.6654 14.1673 15.9154 14.1673 14.9987C14.1673 14.082 13.4173 13.332 12.5006 13.332Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_4628_55454">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </RootSvg>
  );
}
